// The default option for single select (radio) filters in mobile.
// Used when the user has made no filter option selection
export const DEFAULT_RADIO_OPTION = {
  label: 'All',
  value: ''
};